module.exports = __webpack_public_path__ + "img/after school as usual.99b5c9f1.png";